'use client';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { createPolymorphicComponent, Slot, UnstyledButton } from '@s7/base';
import { useProps, packSX } from '@s7/styles';
import { useTabNavigationContext } from '../TabNavigation.context.js';
import { IDENT_TAB_NAVIGATION_ITEM, defaultProps } from './TabNavigationItem.contract.js';
import useStyles from './TabNavigationItem.styles.js';
import { Badge } from '../../Badge/Badge.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const _TabNavigationItem = /*#__PURE__*/ forwardRef((props, ref)=>{
    const _useProps = useProps(IDENT_TAB_NAVIGATION_ITEM, props, defaultProps), [{ title, icon, value, withBadge, badgeProps, className, onClick }, sxs] = _useProps, others = _object_without_properties_loose(_useProps[0], [
        "title",
        "icon",
        "value",
        "withBadge",
        "badgeProps",
        "className",
        "onClick"
    ]);
    const { color, activeColor, activeTab, onChange } = useTabNavigationContext();
    const active = value === activeTab;
    const [classes, cx] = useStyles({
        color,
        activeColor,
        active
    }, sxs, IDENT_TAB_NAVIGATION_ITEM);
    const handleClick = (event)=>{
        onClick == null ? void 0 : onClick(event);
        onChange == null ? void 0 : onChange(value);
    };
    const _icon = /*#__PURE__*/ jsx(Slot, {
        active: active,
        className: classes.icon,
        color: active ? activeColor : color,
        component: icon,
        height: 24,
        width: 24
    });
    const Content = withBadge ? /*#__PURE__*/ jsx(Badge, _extends({
        color: "red",
        size: "0.5rem",
        sx: [
            {
                display: 'inline-flex'
            },
            ...packSX(badgeProps == null ? void 0 : badgeProps.sx)
        ],
        withBorder: false
    }, badgeProps, {
        children: _icon
    })) : _icon;
    return /*#__PURE__*/ jsx(UnstyledButton, _extends({
        as: "a"
    }, others, {
        ref: ref,
        className: cx(classes.root, className),
        onClick: handleClick,
        children: /*#__PURE__*/ jsxs("div", {
            className: classes.inner,
            children: [
                Content,
                /*#__PURE__*/ jsx("span", {
                    className: classes.text,
                    children: title
                })
            ]
        })
    }));
});
const TabNavigationItem = createPolymorphicComponent(_TabNavigationItem);
TabNavigationItem.displayName = 'TabNavigation.Item';

export { TabNavigationItem, TabNavigationItem as default };
//# sourceMappingURL=TabNavigationItem.js.map
